import * as React from "react";
import { useStateValue } from "../Hooks/stateProvider";
import HashLoader  from "react-spinners/HashLoader";
import { useState, useEffect } from "react";
import "./Loader.css";

const override = {
  margin: "0 auto",
};

export default function Loader() {
  const [state, dispatch] = useStateValue();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    updatedDimensions(); 
    window.addEventListener("resize", updatedDimensions);
    return () => window.removeEventListener("resize", updatedDimensions);
  }, []);

  const updatedDimensions = () =>
    window.innerWidth > 768 ? setIsMobile(false) : setIsMobile(true);

  if (!state.pageLoading) return null;

  return (
    <div className="loaderMain">
      <HashLoader  cssOverride={override} color="#154063" />
    </div>
  );
}
